<div class="alerts p-1 p-md-3">
    <div class="alerts__header">
        <h2 #title class="alerts__title" id="alerts-title" tabindex="-1">Active alerts</h2>
        <button mat-stroked-button type="button" (click)="refresh()">Refresh</button>
    </div>

    @if (loadFailed()) {
        <div class="alerts__error" role="alert">The alerts could not be loaded. Refresh to try again.</div>
    }

    @if (counts(); as counts) {
        <dl class="alerts__counts" aria-label="Alerts that need attention">
            <div class="alerts__count">
                <dt>Unowned Critical</dt>
                <dd class="alerts__count-value">{{ counts.unownedCritical }}</dd>
                <dd class="alerts__count-hint">Open Critical alerts nobody has acknowledged for days</dd>
            </div>
            <div class="alerts__count">
                <dt>Active without delivery</dt>
                <dd class="alerts__count-value">{{ counts.activeWithoutDelivery }}</dd>
                <dd class="alerts__count-hint">
                    Open or acknowledged alerts missing a delivery to a switched-on destination
                </dd>
            </div>
            <div class="alerts__count">
                <dt>Undelivered</dt>
                <dd class="alerts__count-value">{{ counts.undelivered }}</dd>
                <dd class="alerts__count-hint">
                    Deliveries to switched-on destinations still not delivered after a grace period
                </dd>
            </div>
        </dl>
    }

    @if (response(); as response) {
        <section class="alerts__list" aria-labelledby="alerts-title">
            @for (alert of response.items; track alert.id) {
                <app-alert-card [alert]="alert" (changed)="refresh()" />
            } @empty {
                <p>{{ response.total === 0 ? "No active alerts." : "No alerts on this page." }}</p>
            }
        </section>

        <mat-paginator
            [length]="response.total"
            [pageSize]="response.pageSize"
            [pageIndex]="page() - 1"
            [hidePageSize]="true"
            [showFirstLastButtons]="true"
            (page)="pageChanged($event)"
            aria-label="Select page of alerts"
        />
    }
</div>
